import React from "react";
import PropTypes from "prop-types";
import { transformCriteriaFromApi } from "../../components/builder-v2/utils/criteriaTransforms";
import CriterionSummary from "../../components/builder-v2/criteria/CriterionSummary";

const CRITERIA_TITLES = {
	realtimeSiteContent: "Realtime Site Content",
	contentConsumption: "Content Consumption",
	demographics: "Demographics",
	syndicated: "Syndicated Data Segments",
	location: "Location",
	technographics: "Technographics",
	domains: "Domains",
	subCohorts: "Sub-Cohorts",
	customUserData: "Custom User Data",
};

function CriteriaGroupsDisplay({ criteriaGroupCondition, criteriaGroups, criteriaConfiguration, customUserDataConfiguration, modifierConfiguration }) {
	if (!criteriaGroups || criteriaGroups.length === 0) return null;

	const groupConditionLabel = (criteriaGroupCondition || "AND").toUpperCase();
	const criteriaConditionLabel = groupConditionLabel === "AND" ? "OR" : "AND";

	return (
		<div className="criteria-groups-display">
			{criteriaGroups.map((group, groupIndex) => (
				<React.Fragment key={`g-${groupIndex}`}>
					{groupIndex > 0 && (
						<div className="criteria-divider criteria-divider--group">
							<span className="criteria-divider-label">{groupConditionLabel}</span>
							<span className="criteria-divider-line" />
						</div>
					)}
					<div className="criteria-group-box">
						{group.map((criterion, criterionIndex) => {
							const { type, data } = transformCriteriaFromApi(criterion);
							const title = CRITERIA_TITLES[type] || type;
							return (
								<React.Fragment key={`c-${groupIndex}-${criterionIndex}`}>
									{criterionIndex > 0 && (
										<div className="criteria-divider criteria-divider--criteria">
											<span className="criteria-divider-label">{criteriaConditionLabel}</span>
											<span className="criteria-divider-line" />
										</div>
									)}
									<div className="criteria-item">
										<div className="criteria-card-header">{title}</div>
										<CriterionSummary type={type} data={data} criteriaConfiguration={criteriaConfiguration} customUserDataConfiguration={customUserDataConfiguration} modifierConfiguration={modifierConfiguration} />
									</div>
								</React.Fragment>
							);
						})}
					</div>
				</React.Fragment>
			))}
		</div>
	);
}

CriteriaGroupsDisplay.propTypes = {
	criteriaGroupCondition: PropTypes.string,
	criteriaGroups: PropTypes.array,
	criteriaConfiguration: PropTypes.array,
	customUserDataConfiguration: PropTypes.array,
	modifierConfiguration: PropTypes.array,
};

export default CriteriaGroupsDisplay;
